module.exports = __webpack_public_path__ + "static/react-47ce6e77f039020ee2e76a10c1e988e9.png";